import React, { useContext, useEffect } from "react";
import SideDrawer from "../../components/SideDrawer";
import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import {
  engagedIcon,
  twitterCmnts,
  twitterIcon,
} from "../../components/SmallComponents/Images";
import { AppContext, serverUrl } from "../../utils";
import axios from "axios";

const boxOneStyle = {
  backgroundColor: "#8102FF",
  height: "300px",
  width: "230px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  pl: 6,
  pr: 3,
  borderRadius: "20px",
};

const boxTwoStyle = {
  backgroundColor: "#A229D4",
  height: "300px",
  width: "230px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  pl: 6,
  pr: 3,
  borderRadius: "20px",
};
const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 500,
  my: 2,
  letterSpacing: "1px",
  fontSize: { xs: "22px", sm: "30px" },
  lineHeight: "50px",
  color: "#ffffff",
};

const paraSyle = {
  fontFamily: "Montserrat",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "25px",
  color: "#ffffff",
};

function PointsDetail() {
  const matches = useMediaQuery("(max-width:600px)");
  const { userDatabaseId, tweetHashTagsData, setTweetHashTagsData } =
    useContext(AppContext);

  useEffect(() => {
    if (userDatabaseId) {
      (async () => {
        try {
          const { data } = await axios.get(
            `${serverUrl}/tweet_hash_tags/${userDatabaseId}`
          );
          setTweetHashTagsData({
            orignalPost: data?.orignalPost,
            totalViews: data?.totalViews,
            comments: data?.comments,
            likes: data?.likes,
            retweet: data?.retweet,
            quote: data?.quote,
            postPoints: data?.postPoints,
            viewsPoints: data?.viewsPoints,
            commentsPoints: data?.commentsPoints,
            likesPoints: data?.likesPoints,
            retweetPoints: data?.retweetPoints,
            quotePoints: data?.quotePoints,
            claimPoints: data?.claimPoints,
          });
        } catch (e) {
          console.log(e);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDatabaseId]);
  return (
    <SideDrawer>
      <Grid
        container
        spacing={3}
        justifyContent={"center"}
        mt={{ xs: 0, md: -12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            gap={3}
            sx={{ flexDirection: { xs: "column", sm: "row", md: "column" } }}
          >
            <Box sx={boxOneStyle}>
              <Box>
                <Box
                  component={"img"}
                  alt=""
                  src={twitterIcon}
                  width={"80px"}
                />
              </Box>
              <Typography variant="h3" sx={headingStyle}>
                {tweetHashTagsData?.orignalPost}
                <span
                  style={{
                    fontSize: matches ? "14px" : "16px",
                    marginLeft: "10px",
                  }}
                >
                  - Original Tweets
                </span>
              </Typography>
              <Typography variant="body1" sx={paraSyle}>
                $BGAI Points: {tweetHashTagsData?.postPoints}
              </Typography>
            </Box>
            <Box sx={boxOneStyle}>
              <Box>
                <Box
                  component={"img"}
                  alt=""
                  src={twitterCmnts}
                  width={"80px"}
                />
              </Box>
              <Typography variant="h3" sx={headingStyle}>
                {tweetHashTagsData?.comments}
                <span
                  style={{
                    fontSize: matches ? "14px" : "17px",
                    marginLeft: "10px",
                  }}
                >
                  - Comments
                </span>
              </Typography>
              <Typography variant="body1" sx={paraSyle}>
                $BGAI Points: {tweetHashTagsData?.commentsPoints}
              </Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            display: "flex",

            justifyContent: { xs: "center", md: "start" },
            alignItems: "center",
          }}
        >
          <Stack>
            <Box sx={boxTwoStyle}>
              <Box>
                <Box
                  component={"img"}
                  alt=""
                  src={engagedIcon}
                  width={"80px"}
                />
              </Box>
              <Typography variant="h3" sx={headingStyle}>
                {tweetHashTagsData?.totalViews}
                <span
                  style={{
                    fontSize: matches ? "14px" : "17px",
                    marginLeft: "10px",
                  }}
                >
                  - Engagement
                </span>
              </Typography>
              <Typography variant="body1" sx={paraSyle}>
                $BGAI Points: {tweetHashTagsData?.viewsPoints}
              </Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </SideDrawer>
  );
}

export default PointsDetail;
